import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { functions } from "../firebase";
import { httpsCallable } from "firebase/functions";

const UpdateCitations = () => {
  const [apiKey, setApiKey] = useState('');
  const [status, setStatus] = useState('');
  const [isRunning, setIsRunning] = useState(false);

  const DELAY_MS = 6000; // 6 seconds

  const handleUpdate = async () => {

    const getCitations = httpsCallable(functions, "getCitations");

    setIsRunning(true);
    setStatus('Fetching papers...');

    try {
      const papersSnapshot = await getDocs(collection(db, 'papers'));
      const papers = papersSnapshot.docs;
      

      let processed = 0;
      for (let i = 0; i < papers.length; i++) {
        
        const paperDoc = papers[i];
        const paper = paperDoc.data();
        const title = paper.title;

        if (!title) continue;
        console.log(`🔍 [${i + 1}/${papers.length}] Querying: ${title}`);
        setStatus(`Querying SerpAPI for: "${title}"`);
        try {
          const result = await getCitations({ title });
          console.log("%% getCitations result", result.data.citations)
          const maybeCitations =
            result.data.citations;

          if (typeof maybeCitations === "number") {
            await updateDoc(doc(db, "papers", paperDoc.id), {
            citations: maybeCitations,
            citationsLastUpdated: new Date().toISOString(),
            });
            console.log(`✅ Updated "${title}" → ${maybeCitations} citations`);
          } else {
            console.warn(`⚠️ query citation info error for "${title}", skipped`);
          }
        } catch (err) {
            console.error(`❌ Error updating "${title}":`, err);
        }

        // ⏱ Delay 36 seconds before next request (except the last)
        if (i < papers.length - 1) {
            await new Promise(resolve => setTimeout(resolve, DELAY_MS));
        }
    
        
        // if (!title) continue;
        // const result = await getCitations({
        //     title, apiKey
        //   });

        // const maybeCitations = result.data.organic_results?.[0]?.inline_links?.cited_by?.total;

        // if (typeof maybeCitations === "number") {
        //     await updateDoc(doc(db, "papers", paperDoc.id), {
        //       citations: maybeCitations,
        //       citationsLastUpdated: new Date().toISOString(),
        //     });
        //     console.log(`✅ Updated "${title}" with ${maybeCitations} citations`);
        // } else {
        //     console.warn(`⚠️ Citation data error for"${title}", skipping update`);
        // }

        // processed++;

        // ⏱ Delay after every 2 queries
        // if (processed % BATCH_SIZE === 0 && processed < MAX_REQUESTS) {
        //     setStatus(`⏳ Waiting 10 seconds to avoid rate limit...`);
        //     await new Promise(resolve => setTimeout(resolve, DELAY_MS));
        // }

      }

      setStatus('✅ Citation update completed.');
    } catch (err) {
      console.error(err);
      setStatus('❌ Failed to update citations.');
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <div style={{ marginTop: '2rem', maxWidth: 600, marginInline: 'auto' }}>
      <h3>📚 Update Citations from SerpAPI</h3>
      <input
        type="text"
        value={apiKey}
        onChange={(e) => setApiKey(e.target.value)}
        placeholder="Enter your SerpAPI Key"
        style={{ width: '100%', marginBottom: '1rem' }}
      />
      <button onClick={handleUpdate} disabled={isRunning}>
        {isRunning ? 'Updating...' : 'Start Citation Update'}
      </button>
      <p style={{ marginTop: '1rem', fontStyle: 'italic' }}>{status}</p>
    </div>
  );
};

export default UpdateCitations;
